import React, { useCallback } from 'react';
import { FileInput } from '@mantine/core';
import { MdUpload } from 'react-icons/md';

interface FileUploadInputProps {
    field: {
        name: string;
        value: string;
    };
    form: {
        setFieldValue: (field: string, value: any) => void;
        setFieldError: (field: string, error: string) => void;
    };
    label?: string;
    description?: string;
    withAsterisk?: boolean;
    onFileChange?: (file: File | null) => void;
    skipUpload?: boolean;
    [key: string]: any;
}

export const FileUploadInput: React.FC<FileUploadInputProps> = ({
    field,
    form,
    label,
    description,
    withAsterisk,
    onFileChange,
    skipUpload,
    ...props
}) => {
    const handleFileChange = useCallback((file: File | null) => {
        // Update form field with file name
        form.setFieldValue(field.name, file?.name || '');
        
        // Clear any previous errors
        form.setFieldError(field.name, '');
        
        // Call the optional onFileChange callback
        if (onFileChange) {
            onFileChange(file);
        }
    }, [field.name, form, onFileChange]);

    return (
        <FileInput
            {...props}
            label={label}
            description={description}
            withAsterisk={withAsterisk}
            placeholder="Select a file..."
            leftSection={<MdUpload size={16} />}
            accept=".csv,.ods"
            onChange={handleFileChange}
            clearable
        />
    );
};